import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { icon, LatLng, latLng, marker, tileLayer } from 'leaflet';
import { combineLatest, from, Observable, of, Subscription, Subject, concat, empty } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, tap, filter } from 'rxjs/operators';
import { AppConfig } from '../../app.config';
import { DataService } from '../../services/data.service';
import { GeocodingService } from '../../services/geocoding.service';
import { ManageReportService } from '../../services/manage-report.service';
import { TicketUiModel } from '../../services/model/ui/ticket.ui.model';
import { StreetViewService } from '../../services/street-view.service';
import { UploadService } from '../../services/upload.service';
import { PreviousRouteService } from '../../services/previous-router.service';
import { ReasonComponent } from '../modals/reason/reason.component';
import {
  StreetViewModalComponent,
  StreetViewModalState
} from '../modals/street-view-modal/street-view-modal.component';

import { Categories, CategoryUiModel } from './category.ui.model';
import { InfoModalComponent } from "../modals/info-modal/info-modal.component";
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.gridlayer.googlemutant';
import { NgSelectComponent } from '@ng-select/ng-select';
import { debounce } from 'lodash';
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';


@Component({
  selector: 'app-new-report',
  templateUrl: './new-report.component.html',
  styleUrls: ['./new-report.component.scss']
})
export class NewReportComponent implements OnInit, OnDestroy {
  public leafletOptions: any;
  public layers: any[] = [];
  public originalBounds;
  public categories: Array<CategoryUiModel> = [];
  public headerTxt = 'New report';
  public mode: 'add' | 'edit' | 'inbox' | 'view' | 'accepted' = 'add';
  public category: CategoryUiModel;
  public address: string;
  public backQParams = {};

  dict: any;

  public ticket: TicketUiModel = {
    transport: null,
    category: null,
    solution: null,
    description: null,
    geometry: [],
    image: [],
    status: null,
    weeks_visible: null,
    votes: null,
    reporters: null,
    advice: null,
    visible: null,
    invisible_due_to_merge: null,
    address: null,
  };
  public center: LatLng = new LatLng(0, 0);
  private map: L.Map;
  public tiles = [];
  public currentTileIdx = 1;

  public isGeneral = true;
  public isAdvice = false;
  public isReaction = false;
  public advice: string;
  public reactions = [];
  public isNoneReactions = true;
  public pageSize = 5;
  public page = 1;
  public isRejectedReport = false;

  public role = 'user';

  public weeks_visible = "0";

  public id;
  public projectId;

  public choices = [
    {
      'key': 'REPORTED',
      'value': 'Reported',
      'icon': 'assets/img/mark_reported.png'
    },
    {
      'key': 'COMPLETED',
      'value': 'Resolved',
      'icon': 'assets/img/mark_completed.png'
    },
    {
      'key': 'PROCESSING',
      'value': 'In Progress',
      'icon': 'assets/img/mark_neutral.png'
    }
  ];

  public markerIcons = {
    'REPORTED': new L.Icon({
      iconSize: [47, 57],
      iconUrl: 'assets/img/mark_reported.png',
      iconAnchor: [24, 57]
    }),
    'COMPLETED': new L.Icon({
      iconSize: [47, 57],
      iconUrl: 'assets/img/mark_completed.png',
      iconAnchor: [24, 57]
    }),
    'PROCESSING': new L.Icon({
      iconSize: [47, 57],
      iconUrl: 'assets/img/mark_neutral.png',
      iconAnchor: [24, 57]
    })
  };

  public ICONS = {
    'REPORTED': 'assets/img/mark_reported.png',
    'COMPLETED': 'assets/img/mark_completed.png',
    'PROCESSING': 'assets/img/mark_neutral.png'
  }

  public transLabels = ['foot', 'bike', 'moped', 'schoolbus', 'train', 'bus_tram_metro', 'car', 'other'];
  public transports = [];

  address$: Observable<any[]>;
  addressLoading: boolean = false;
  addressInput$ = new Subject<string>();
  private routeSub = null;

  public isLoading = false;
  public isLoaded = false;

  public invisibleReport = 0;
  public reportVisible = false;
  public visibleKey = 'invisible_due_to_merge';

  public previousUrl: string;

  ticketSubject;

  unlimitedTranslationSub: Subscription;
  sendReportSub: Subscription;

  group: L.FeatureGroup;

  projectNames = {};

  isImgAdded: boolean = false;
  @ViewChild('imageRef', { static: false }) private imgContainer: ElementRef;
  @ViewChild(NgSelectComponent, { static: false }) ngSelectComponent: NgSelectComponent;

  constructor(
    private appConfig: AppConfig,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private service: DataService,
    private geocodingService: GeocodingService,
    private manageReportservice: ManageReportService,
    private modalService: NgbModal,
    private router: Router,
    private uploadService: UploadService,
    private streetViewService: StreetViewService,
    private translateService: TranslateService,
    private userService: UserService,
    private previousRouteService: PreviousRouteService
  ) {
    console.log('prev: ', previousRouteService.getPreviousUrl());
    this.saveInput = debounce(this.saveInput, 2000);
    this.save = debounce(this.save, 200);
  }

  ngOnInit() {

    const project = JSON.parse(localStorage.getItem('project_id'));

    this.projectNames[(project['projectID'] || {})['id']] = project['projectName'];
    for (const subProject of (project.children || [])) {
      this.projectNames[(subProject['projectID'] || {})['id']] = subProject['projectName'];
    }

    var project_lng = this.translateService.getDefaultLang();
    this.group = L.featureGroup();

    this.categories = Categories.get();

    this.userService.getUserInfo().subscribe(user => this.addHomeMarker());

    if (this.transLabels.length) {
      this.service.getDictionary(project_lng).pipe(
        map((e) => {

          this.dict = e;

          let coun = [];
          Object.keys(e).filter(key => this.transLabels.includes(key)).reduce((obj, key) => {
            obj[key] = e[key];

            var className = "";
            var imgId = 0;
            if (key == 'foot') {
              className = "foots";
              imgId = 1;
            }
            else if (key == 'bike') {
              className = "bike";
              imgId = 2;
            }
            else if (key == 'moped') {
              className = "moto";
              imgId = 3;
            }
            else if (key == 'schoolbus') {
              className = "bus";
              imgId = 4;
            }
            else if (key == 'train') {
              className = "train";
              imgId = 5;
            }
            else if (key == 'bus_tram_metro') {
              className = "express";
              imgId = 6;
            }
            else if (key == 'car') {
              className = "car";
              imgId = 7;
            }
            else if (key == 'other') {
              className = "other";
              imgId = 8;
            }

            coun.push({
              'key': key,
              'value': obj[key],
              'class': className,
              'img': imgId
            });
            return obj;
          }, {});
          return coun;

        }),
        map((items) => {
          this.transports = items.sort((a, b) => (a.img > b.img) ? 1 : -1);
        })
      ).subscribe();
    }

    (!this.isViewMode()) && this.initTypeahead();
    combineLatest([this.activatedRoute.params, this.activatedRoute.data]).pipe(
      tap(([it, data]) => {

        this.id = it.id;
        this.projectId = it.projectId || this.userService.project.projectID.id;
        this.role = data.role || 'user';

        if (it.mode === 'rejected') {
          this.mode = 'inbox';
          this.isRejectedReport = true;
        } else {
          this.mode = it.mode || 'add';
        }
        this.headerTxt = {
          view: 'View report',
          edit: 'Edit report',
          accepted: 'Accepted report details',
          add: 'New report',
          inbox: 'Inbox report details',
          rejected: 'Rejected report details'
        }[it.mode || 'add'];

        this.routeSub = this.mode === 'add' && this.router.events.subscribe((event) => {
          if (event instanceof NavigationStart) {
            if (!this.id && this.mode === 'add') {
              const image = this.ticket.image;
              let api$ = image.map(img => {
                return this.uploadService.remove(img.id)
              });
              combineLatest(api$).subscribe(() => {
              }, err => {
                console.log(err)
              });
            }
          }
        });

      }),
      switchMap(([it, data]) => {
        return it.projectId && it.id ? this.getReport(it.projectId, it.id) : of(null);
      })
    ).subscribe();

    const tileLayerOptions = {
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.tiles = [
      // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions),
      // @ts-ignore
      L.gridLayer.googleMutant({ type: 'satellite' }),
      this.appConfig.getTileLayer()
    ];

    const project_location = localStorage.getItem('project_location');
    let latlng;
    if (!project_location) { latlng = latLng(50.848656786354994, 4.349341392517091); }
    else {
      const locations = project_location.split(',');
      var latitude = parseFloat(locations[1]),
        longitude = parseFloat(locations[0]);
      latlng = L.latLng(latitude, longitude);
    }

    this.leafletOptions = {
      layers: [
        this.tiles[1]
      ],
      zoom: 14,
      center: latlng
    };

    if (this.role == 'management' && !this.isViewMode())
      this.backQParams = { closure: this.isRejectedReport ? 'rejected' : this.mode }
  }

  public ngOnDestroy() {
    this.routeSub && this.routeSub.unsubscribe();
  }

  toggleMapType() {
    try {
      this.tiles[this.currentTileIdx].removeFrom(this.map);
    } catch { }
    // this.currentTileIdx = this.currentTileIdx == 2 ? 0 : this.currentTileIdx + 1;
    this.currentTileIdx = this.currentTileIdx == 1 ? 0 : this.currentTileIdx + 1;
    this.tiles[this.currentTileIdx].addTo(this.map);
  }

  deleteSelectItem() {
    this.ngSelectComponent.handleClearClick();
  }

  initTypeahead() {
    const project_location = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            let latlng;
            if (!project_location) { latlng = this.map.getCenter(); }
            else {
              const locations = project_location.split(',');
              var latitude = parseFloat(locations[1]),
                longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              map(result => {
                if (result.features) return result.features.map(r => {
                  let retItem = Object.assign(r.properties, r.geometry);
                  retItem.street = retItem.name;
                  switch (retItem.countrycode.toLowerCase()) {
                    case 'be':
                    case 'nl':
                      retItem.name = `${retItem.name || ''}${retItem.houseNumber ? ' ' + retItem.houseNumber : ''}, ${retItem.postcode || ''} ${retItem.city || ''}`;
                      break;
                    case 'ca':
                      retItem.name = `${retItem.houseNumber ? retItem.houseNumber + ' ' : ''}${retItem.name || ''}, ${retItem.city || ''}${retItem.provincecode ? ' ' + retItem.provincecode : ''} ${retItem.postcode || ''}`;
                      break;
                    default:
                      break;
                  }
                  console.log(retItem)
                  return retItem;
                });
                else return [];
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    )
  }

  getReport(projectId, id) {
    let get: Observable<any>;
    if (this.role == 'user') {
      get = this.service.getISentReport(projectId);
    }
    else if (this.role == 'management') {
      get = this.service.getReportHistory(projectId, id);
    }
    return get
      .pipe(
        switchMap(r => {
          let retSub: Observable<any> = empty();
          this.isNoneReactions = true;
          this.reactions = [];

          if (this.role == 'user') {
            r = r.filter(e => e.entityID.id2 == id)
              .map(it => {
                return {
                  transport: it.genericAttributes.attributes.transportMode[0],
                  category: it.genericAttributes.attributes.category ? it.genericAttributes.attributes.category[0] : "",
                  solution: it.genericAttributes.attributes.solution[0],
                  description: it.genericAttributes.attributes.description[0],
                  geometry: it.genericAttributes.attributes.geometry,
                  image: it.genericAttributes.attributes.image || [],
                  status: it.genericAttributes.attributes.status ? it.genericAttributes.attributes.status[0] : "REPORTED",
                  weeks_visible: it.genericAttributes.attributes.weeks_visible ? it.genericAttributes.attributes.weeks_visible[0] : 0,
                  advice: it.genericAttributes.attributes.advice ? it.genericAttributes.attributes.advice[0] : "",
                  visible: it.genericAttributes.attributes.visible ? it.genericAttributes.attributes.visible[0] : false,
                  invisible_due_to_merge: it.genericAttributes.attributes.invisible_due_to_merge ? true : false,
                  address: it.genericAttributes.attributes.address[0]
                };
              })
            this.ticket = r[0];
            this.address = [
              this.ticket.address.postalCode,
              this.ticket.address.municipality,
              this.ticket.address.street,
              this.ticket.address.houseNumber,
              this.ticket.address.boxNumber
            ]
              .filter(i => !!i)
              .join(', ');
            this.isLoaded = true;
          } else {
            this.ticket = {
              transport: (this.filterAttribute(r.attributes.transportMode).length > 0) && this.filterAttribute(r.attributes.transportMode)[0].value,
              category: (this.filterAttribute(r.attributes.category).length > 0) && this.filterAttribute(r.attributes.category)[0].value,
              solution: (this.filterAttribute(r.attributes.solution).length > 0) && this.filterAttribute(r.attributes.solution)[0].value,
              description: (this.filterAttribute(r.attributes.description).length > 0) && this.filterAttribute(r.attributes.description)[0].value,
              geometry: this.filterAttribute(r.attributes.geometry).map(geo => {
                return {
                  type: geo.value.type,
                  coordinates: [geo.value.coordinates[1], geo.value.coordinates[0]]
                }
              }),
              image: this.filterAttribute(r.attributes.image).map(img => {
                return { id: img.value };
              }) || [],
              status: (this.filterAttribute(r.attributes.status).length > 0) ? this.filterAttribute(r.attributes.status)[0].value : "REPORTED",
              weeks_visible: (this.filterAttribute(r.attributes.weeks_visible).length > 0) ? this.filterAttribute(r.attributes.weeks_visible)[0].value : 0,
              advice: (this.filterAttribute(r.attributes.advice).length) > 0 && this.filterAttribute(r.attributes.advice)[0].value || "",
              visible: (this.filterAttribute(r.attributes.visible).length) > 0 && this.filterAttribute(r.attributes.visible)[0].value || false,
              invisible_due_to_merge: (this.filterAttribute(r.attributes.invisible_due_to_merge).length > 0) ? true : false,
              votes: r.attributes.like.length,
              reporters: null,
              address: null,
            }
            const address = (this.filterAttribute(r.attributes.address).length > 0) ? this.filterAttribute(r.attributes.address)[0].value : {
              boxNumber: "",
              country: "",
              houseNumber: "",
              municipality: "",
              postalCode: "",
              street: ""
            };
            this.address = [
              address.postalCode,
              address.municipality,
              address.street,
              address.houseNumber,
              address.boxNumber
            ]
              .filter(i => !!i)
              .join(', ');
            this.ticket.address = address;

            if (r.attributes.message.length) {
              this.isNoneReactions = false;
              this.reactions = r.attributes.message;
            }
            retSub = this.service.getReporters(projectId, id);
          }

          this.unlimitedTranslationSub && this.unlimitedTranslationSub.unsubscribe();
          this.unlimitedTranslationSub = this.translateService.stream("Unlimited").subscribe(d => {
            this.weeks_visible = this.ticket.weeks_visible == 2147483647 ? d : this.ticket.weeks_visible.toString();
          });
          this.category = Categories.valueOf(this.ticket.category);
          this.layers.push(this.markerReported(this.ticket.geometry[0].coordinates[1], this.ticket.geometry[0].coordinates[0], this.ticket.status));
          this.map.panTo({
            lng: this.ticket.geometry[0].coordinates[0],
            lat: this.ticket.geometry[0].coordinates[1]
          });
          if (this.ticket[this.visibleKey]) {
            this.invisibleReport = 2;
            this.reportVisible = false;
          } else {
            this.invisibleReport = 1;
            this.reportVisible = this.ticket.visible;
          }
          return retSub;
        }),
        tap(r => {
          if (r) {
            this.ticket.reporters = r.length;
          }
          this.isLoaded = true;
        })
      );
  }

  filterAttribute(attribute) {
    if (attribute.length > 0) {
      return attribute.filter(at => {
        return !at.deleted;
      })
    } else return [];
  }

  selectCategory(item) {
    if (this.isViewMode()) return;
    this.category = item;
    this.ticket.category = this.category.code;
    this.save('category');
  }

  send() {
    const project = JSON.parse(localStorage.getItem('project_id'));
    this.sendReportSub = this.service.sendReport(project.projectID.id, this.ticket, 'address').subscribe(res => {
      this.id = res.id2;
      this.router.navigate(['reports']);
    }, error => console.log(error));
  }

  save(key) {
    if (key === 'status') {
      try {
        const marker = this.layers[0];
        if (marker) {
          marker.setIcon(this.markerIcons[this.ticket.status]);
          var project_lng = this.translateService.getDefaultLang();
          this.service.statusUpdate(this.projectId, this.id, this.ticket.status, project_lng).subscribe(res => {
          }, error => console.log(error));
        }
      } catch {

      }
    }

    if (!this.isLoaded) {
      return;
    }

    if (this.isAdvice) {
      this.activatedRoute.params
        .pipe(
          switchMap(it => this.service.setAdvice(this.ticket.advice, it.projectId, it.id))
        )
        .subscribe(() => {
          // const infoDlg = this.modalService.open(InfoModalComponent);
          // infoDlg.componentInstance.data = {
          //   text: 'This advice is just saved.',
          //   header: 'Info'
          // };
        });
    }
    else {
      if (isNaN(parseInt(this.weeks_visible))) {
        this.ticket.weeks_visible = 2147483647;
      }
      else {
        this.ticket.weeks_visible = parseInt(this.weeks_visible);
      }

      let api$ = [];
      if (key === 'geometry') {
        api$ = [
          this.service.locationUpdate(this.projectId, this.id, this.ticket, key),
          this.service.updateReportAttribute(this.projectId, this.id, this.ticket, 'address')
        ];
      }
      else {
        api$ = [
          this.service.locationUpdate(this.projectId, this.id, this.ticket, key),
          this.service.updateReportAttribute(this.projectId, this.id, this.ticket, key)
        ];
      }
      combineLatest(api$).subscribe(() => {
      }, err => {
      });
    }

  }

  saveInput(key) {
    this.save(key);
  }

  selectTransport(event) {
    if (!['inbox', 'view'].includes(this.mode) || this.accMan) {
      this.ticket.transport = event;
      this.save('transport');
    }
  }

  updateVisibility() {
    this.service.updateTicketVisibility(this.reportVisible, this.projectId, this.id).subscribe();
  }

  mapClick(event) {
    if (this.isViewMode()) return;
    if (event.originalEvent.target.classList.contains('map-type-trigger') || event.originalEvent.target.classList.contains('fas')) {
      return;
    }

    if (this.mode !== 'accepted') {
      this.getCoordinates(event);
    }
  }

  getCoordinates(event) {
    this.layers = [this.markerReported(event.latlng.lat, event.latlng.lng, this.ticket.status)];
    this.findAddress(event.latlng.lat, event.latlng.lng);
  }

  findAddress(lat: any, lng: any) {
    this.geocodingService.findAddress(lat, lng).subscribe(response => {
      this.address = [
        response.postalCode,
        response.municipality,
        response.street,
        response.houseNumber,
        response.boxNumber
      ]
        .filter(i => !!i)
        .join(', ');
      const point = {
        type: 'Point',
        coordinates: [
          lng,
          lat,
        ]
      };
      this.ticket.geometry = [point];
      this.ticket.address = {
        postalCode: response.postalCode,
        municipality: response.municipality,
        street: response.street,
        houseNumber: response.houseNumber,
        boxNumber: response.boxNumber
      };

      if (this.isLoaded) {
        this.save('geometry');
      }
    }, err => {
      if (err.status === 404) {
        this.address = '';
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The address of this location could not be determined. Please select a new location.';
        errDlg.result.then(() => {
          this.layers.forEach(m => {
            this.group.removeLayer(m);
          })
          this.layers = []
        });
      }
    });
  }

  findPos(latlng) {
    this.center.lat = latlng.lat;
    this.center.lng = latlng.lon ? latlng.lon : latlng.lng;
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);
    const point = {
      type: 'Point',
      coordinates: [
        latlng.lon ? latlng.lon : latlng.lng,
        latlng.lat,
      ]
    };
    this.ticket.geometry = [point];
    this.layers = [this.markerReported(latlng.lat, latlng.lon ? latlng.lon : latlng.lng, this.ticket.status)];
    this.save('geometry');
  }

  onInputAddress(event) {
    this.ticket.address = {
      postalCode: event.postcode,
      municipality: event.city,
      street: event.street,
      houseNumber: '',
      boxNumber: ''
    };

    if (event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng);
    }
    else if (event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  markerReported(lat, lng, status) {
    const markerInstance = this.marker(lat, lng, this.ICONS[status || 'REPORTED']);

    if (this.mode === 'add') {
      this.generatePanorama(lat, lng);
    }

    return markerInstance;
  }

  generatePanorama(lat, lng) {
    this.streetViewService.generatePanoramaObject({ lat, lng })
      .then(data => {
        const svModal = this.modalService.open(StreetViewModalComponent, {
          size: 'lg',
          backdrop: 'static'
        });
        const componentInstance = svModal.componentInstance;
        componentInstance.data = data;
        componentInstance.images = this.ticket.image;
        componentInstance.disabled = !this.canAddImage();

        componentInstance.addImageChange.subscribe((state: StreetViewModalState) => {
          componentInstance.inserting = true;
          if (state == null) {
            return;
          }

          if (!this.canAddImage()) {
            return;
          }

          const resultLat = state.location.lat();
          const resultLng = state.location.lng();
          const resultPano = state.pano;
          const resultPov = state.pov;

          this.streetViewService.postImage(
            { lat: resultLat, lng: resultLng }, resultPano, resultPov.heading, resultPov.pitch, resultPov.zoom)
            .subscribe(id => {
              this.addImage(id);
              componentInstance.inserting = false;
              componentInstance.images = this.ticket.image;
              if (!this.canAddImage()) {
                componentInstance.disabled = true;
              }
            });
        });
      })
      .catch(status => {
        console.log(`No street view available: ${status}`);
      });
  }

  marker(lat, lng, iconpic) {
    let m = marker([lat, lng], {
      draggable: this.mode === 'add' || this.mode === 'accepted',
      icon: icon({
        iconSize: [47, 57],
        iconUrl: iconpic,
        iconAnchor: [24, 57]
      })
    }).on('click', () => {
      this.cd.detectChanges();
    });

    m.addTo(this.group);
    this.originalBounds.extend(this.group.getBounds());
    this.map.fitBounds(this.originalBounds);

    if (this.mode === 'add' || this.mode === 'accepted') {
      m.on('dragend', (e) => {
        const param = {
          latlng: {
            lat: e.target._latlng.lat,
            lng: e.target._latlng.lng
          }
        }
        this.getCoordinates(param);

        if (this.canAddImage()) {
          this.generatePanorama(e.target._latlng.lat, e.target._latlng.lng);
        }
      });
    }

    return m;
  }

  onMapReady(event: L.Map) {
    this.map = event;
    this.group.addTo(this.map);

    this.originalBounds = this.map.getBounds();
  }

  addImage(id) {
    this.ticket.image.push({ id });
    this.isImgAdded = true;

    if (this.id) {
      this.service.addReportImage(this.projectId, this.id, id).subscribe((res) => { }, err => {
        console.log(err)
      })
    }
  }

  canAddImage(): boolean {
    const images = this.ticket.image;
    return images != null && images.length < 3;
  }

  removeImage(id) {
    this.isLoading = true;
    let api$ = [this.uploadService.remove(id)]
    if (this.id) {
      api$.push(this.service.removeReportImage(this.projectId, this.id, id));
    }
    combineLatest(api$).subscribe(() => {
      this.ticket.image = this.ticket.image.filter(i => i.id !== id);
      this.isLoading = false;
    }, err => {
      console.log(err)
      this.isLoading = false;
    });
  }

  imageToLink(id) {
    if (this.isImgAdded) {
      this.isImgAdded = false;
      this.imgContainer.nativeElement.scrollIntoView();
    }
    return `${this.appConfig.getHost()}/api2/public/image?image_id=${id}&dimension=250`;
  }

  isNotEmpty() {
    return !this.address
      || !this.ticket.category
      || !this.ticket.transport
      || !this.ticket.description
      || !this.ticket.solution;
  }

  public onGeneral() {
    this.isGeneral = true;
    this.isAdvice = false;
    this.isReaction = false;
  }

  public onAdvice() {
    this.isGeneral = false;
    this.isAdvice = true;
    this.isReaction = false;
  }

  public onReaction() {
    this.isGeneral = false;
    this.isAdvice = false;
    this.isReaction = true;
  }

  onConfirmAdvice() {
    this.isLoading = true;
    this.activatedRoute.params
      .pipe(
        switchMap(it => this.service.setAdvice(this.ticket.advice, it.projectId, it.id))
      )
      .subscribe(() => {
        this.isLoading = false;
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'This advice is just saved.',
          header: 'Info'
        };
      });
  }

  onRestoreReport() {
    this.activatedRoute.params
      .pipe(
        switchMap(it => this.service.restoreReport(it.projectId, it.id))
      )
      .subscribe(() => {
        this.router.navigate(['/management', 'report']);
      });
  }

  public accept() {
    this.activatedRoute.params.pipe(
      switchMap(it => this.manageReportservice.accept(it.projectId, it.id, null, null))
    ).subscribe(() => {
      this.router.navigate(['/management', 'report']);
    });
  }

  public reject() {

    this.activatedRoute.params.pipe(
      switchMap(it => {
        return from(this.modalService.open(ReasonComponent, {}).result).pipe(
          catchError(e => of(null)),
          switchMap(reason => {
            console.log('reason:', reason);
            return reason === null
              ? of(null)
              // : this.manageReportservice.reject(it.projectId, it.id, reason, null)
              : of('yes');
          })
        );
      })
    ).subscribe((result) => {
      if (result !== null) {
        this.router.navigate(['/management', 'report']);
      }
    });

  }

  public get accMan() {
    return ((this.mode === 'accepted' && this.role === 'management') || this.mode === 'add');
  }

  addHomeMarker() {
    let userLocation = this.userService.user.attributes.location[0].coordinates;
    var homeMarker = L.marker(new L.LatLng(userLocation[1], userLocation[0]), {
      icon: L.icon({ iconUrl: 'assets/marker/home.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
      draggable: false
    });

    homeMarker.bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    homeMarker.addTo(this.group);
    this.originalBounds.extend(this.group.getBounds());
    this.map.fitBounds(this.originalBounds);
  }

  getProjectName(projectId) {
    return this.projectNames[projectId];
  }

  isViewMode() {
    return this.mode === 'view';
  }

  isActiveTransportMode = (t) => {
    return this.ticket.transport === t.key.toUpperCase();
  }
}
